/**
 * ConfirmationBanner — the "Draft created — start another" status banner (R5),
 * shown on the wizard's landing step after a "Create & add another" reset.
 *
 * Extracted from LocationStep so each file declares one component
 * (`react/no-multi-comp`); behaviour is unchanged.
 */
export function ConfirmationBanner({ message }: { message: string | null }) {
  if (!message) return null;
  return (
    <div
      role="status"
      style={{
        fontSize: 11.5,
        fontWeight: 700,
        color: 'var(--nb-primary)',
        background: 'var(--nb-primary-soft)',
        borderRadius: 8,
        padding: '8px 10px',
      }}
    >
      {message}
    </div>
  );
}
